// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Status_dropdown__2CzIl","toggle":"Status_toggle__3dzoV","disablePointer":"Status_disablePointer__1cJDF"};